import { AppTrackingTransparency } from "capacitor-plugin-app-tracking-transparency";
import { Capacitor } from "@capacitor/core";

export const useAppTracking = () => {
  const requestTrackingPermission = async () => {
    if (!Capacitor.isNativePlatform()) {
      return { status: "web" };
    }

    try {
      const result = await AppTrackingTransparency.requestPermission();
      return result;
    } catch (error) {
      console.error("Error requesting tracking permission:", error);
      return { status: "error" };
    }
  };

  const getTrackingStatus = async () => {
    if (!Capacitor.isNativePlatform()) {
      return { status: "web" };
    }

    try {
      const result = await AppTrackingTransparency.getStatus();
      return result;
    } catch (error) {
      console.error("Error getting tracking status:", error);
      return { status: "error" };
    }
  };

  return {
    requestTrackingPermission,
    getTrackingStatus,
  };
};
